import React, { FC, useMemo } from 'react'
import Select from 'components/SA/Select'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import HitsPerPageConnector, { ConnectorProps as HitsPerPageConnectorProps } from 'connectors/Algolia/HitsPerPage'

import { updateFeatureUrl } from '../helpers/url'
import type { ConnectorProps as URLProps } from '../connectors/Url'
import URLConnector from '../connectors/Url'
import styles from './SelectHitsPerPage.module.scss'

const options = [25, 50, 100]

type Props = HitsPerPageConnectorProps & URLProps

const SelectHitsPerPage: FC<Props> = (props) => {
  const { hitsPerPage, getHref } = props
  const handleChangeHitsPerPage = ({ value }) => {
    const params = {
      hitsPerPage: value,
      page: '',
    }

    const href = getHref(params)
    handleScrollToTop(() => updateFeatureUrl(href))
  }

  const numberOfHitsArray = useMemo(() => {
    return options.map((numberResults) => ({
      label: `${numberResults} Results Per Page`,
      value: `${numberResults}`,
    }))
  }, [])

  const selectValue = useMemo(
    () => numberOfHitsArray.find(({ value }) => value === `${hitsPerPage}`),
    [hitsPerPage, numberOfHitsArray]
  )

  return (
    <div className={styles.selectContainer}>
      <Select
        value={selectValue}
        onChange={handleChangeHitsPerPage}
        aria-label='Results Per Page'
        dataSection='hits-per-page'
        options={numberOfHitsArray}
      />
    </div>
  )
}

export default HitsPerPageConnector(URLConnector(SelectHitsPerPage))
